<script setup>
import { computed } from "vue";

const props = defineProps({
  weeks: { type: Number, default: 26 },
  activeDays: { type: Array, required: true }, // indices into the grid
  months: { type: Array, default: () => ["Jan", "Feb", "Mar", "Apr", "May", "Jun"] },
});

// Deterministic intensity per active day (no Math.random — keeps SSR/build stable)
const active = computed(() => {
  const map = {};
  props.activeDays.forEach((d, i) => {
    map[d] = 0.4 + ((i * 37) % 60) / 100; // 0.4 .. 0.99
  });
  return map;
});

const cells = computed(() =>
  Array.from({ length: props.weeks * 7 }, (_, i) =>
    active.value[i] ? `rgba(139,124,246, ${active.value[i].toFixed(2)})` : null
  )
);
</script>

<template>
  <div>
    <div class="an-cal__months"><span v-for="m in months" :key="m">{{ m }}</span></div>
    <div class="an-cal">
      <div v-for="(bg, i) in cells" :key="i" class="an-cal__cell" :style="bg ? { background: bg } : null"></div>
    </div>
  </div>
</template>
